//import { Link } from "react-router-dom";
import { useState, useContext } from "react";
import { motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthProvider";
import Dropdown from "../Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";

const Sidebar = ({sidebarLinks, toggleMenu, menuStatus}) => {
  const {pathname}=useLocation()
  const [toggleDropDown, setToggleDropDown] = useState(false);
  const [myIndex, setMyIndex] = useState();
  const { user } = useContext(AuthContext);
  const handleToggle = (index) => {
    if (index !== myIndex) {
      setToggleDropDown(true);
      setMyIndex(index);
      return;
    }
    if (!index) return;
    setMyIndex(index);
    setToggleDropDown(!toggleDropDown);
  };

 const links= sidebarLinks.map((link, index) =>  (
    <li
      onClick={() => handleToggle(index)}
      key={link.name}
      className={`text-xl bg-gray-700 p-1 w-full ${link.url.endsWith(pathname)?"text-yellow-600":"text-white"}`}
    >
      <Link to={link.url}>
        <span
        onClick={link.subLinks?null:toggleMenu}
          className={
            link.subLinks
              ? "flex gap-6 mb-1"
              : "hover:text-yellow-900 flex gap-6 py-1"
          }
        >
          <FontAwesomeIcon icon={link.icon} className="mt-1" />
          {link.name}
          {link.subLinks && (
            <FontAwesomeIcon
              icon={faArrowCircleDown}
              size="sm"
              className="-ml-4 mt-2"
            />
          )}
        </span>
      </Link>
      {link.subLinks && (
        <Dropdown
        toggleSideBar={toggleMenu}
          toggle={toggleDropDown}
          index={index}
          myIndex={myIndex}
          dropdownLinks={link.subLinks}
        />
      )}
    </li>
  ));

  return (
    <aside className={`pt-0 pr-4 overflow-y-auto overflow-x-hidden fixed top-[50px] left-0 md:sticky max-w-[50%] min-w-[250px] md-left-0 h-full md:h-[100vh] z-20 ${menuStatus? "block": "hidden"} md:block`}>

      <div className="hidden w-64 h-full bg-gray-800 text-white shadow-lg md:flex flex-col py-6 px-3 z-10">
        <div className="flex gap-4 pb-3 text-2xl">
          <div className="rounded-full bg-white h-10 w-10"></div>
          <span className="pt-1 overflow-ellipsis capitalize">{user.username}</span>
        </div>
        <ul className="flex flex-col space-y-4 w-full">{links}</ul>
      </div>

      {/* Sidebar (Mobile) */}
      {menuStatus && (
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: 0 }}
          exit={{ x: "-100%" }}
          transition={{ duration: 0.3 }}
          className="block md:hidden w-full h-full pt-3 bg-gray-800 text-white min-w[260px] px-3 shadow-lg z-10 sm:z-100 flex-col"
        >
           <div className="flex gap-4 pb-3 text-2xl">
          <div className="rounded-full bg-white h-10 w-10"></div>
          <span className="pt-1 overflow-ellipsis capitalize">{user.username}</span>
        </div>
          <ul
            className="flex flex-col space-y-4 w-full over-flow-auto"
          >
            {links}
          </ul>
        </motion.div>
      )}
      </aside>
  );
};

export default Sidebar;
